<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-play`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.082 4.32l28 17.998a2 2 0 010 3.364l-28 17.997C9.75 44.535 8 43.58 8 41.997V6.003C8 4.42 9.75 3.465 11.082 4.32zM12 9.667v28.668L34.301 24 12 9.666z"/></svg>
</template>
<script>

export default {
  name: 'IconPlay',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
